// extracted by mini-css-extract-plugin
module.exports = {"loading":"LoadingBox_loading__oUFRA"};